import { Injectable } from '@angular/core';
import {
  CanActivate,
  CanActivateChild,
  Router,
  UrlTree,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { StudentFeaturePreferencesService } from '../services/student-feature-preferences.service';
import { TrainerFeaturePreferencesService } from '../services/trainer-feature-preferences.service';
import { resolveFeatureForUrl } from '../models/student-feature-preferences';
import { resolveTrainerFeatureForUrl } from '../models/trainer-feature-preferences';
import { RoutesApp } from '../models/enums/routes-app.enum';

/**
 * Bloqueia rotas de features desabilitadas pelo aluno ou pelo personal.
 */
@Injectable({
  providedIn: 'root',
})
export class FeaturePreferenceGuard implements CanActivate, CanActivateChild {
  constructor(
    private readonly authService: AuthService,
    private readonly studentFeaturePrefs: StudentFeaturePreferencesService,
    private readonly trainerFeaturePrefs: TrainerFeaturePreferencesService,
    private readonly router: Router
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    return this.check(state.url);
  }

  canActivateChild(
    _childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | UrlTree {
    return this.check(state.url);
  }

  private check(url: string): boolean | UrlTree {
    const user = this.authService.getCurrentUser();
    if (!user) {
      return true;
    }

    if (user.userType === 'student') {
      const featureId = resolveFeatureForUrl(url);
      if (!featureId || this.studentFeaturePrefs.isEnabled(featureId)) {
        return true;
      }
      return this.router.createUrlTree([`/${RoutesApp.STUDENT_USER_PROFILE}`]);
    }

    if (user.userType === 'trainer') {
      const featureId = resolveTrainerFeatureForUrl(url);
      if (!featureId || this.trainerFeaturePrefs.isEnabled(featureId)) {
        return true;
      }
      return this.router.createUrlTree([`/${RoutesApp.TRAINER_DASHBOARD}`]);
    }

    return true;
  }
}
